import client1 from "../../assets/img/client1.png";
import client2 from "../../assets/img/client2.png";

const clientsOpinions = [
    {
        id: "client_1",
        name: "همس عبدالله",
        pic: client2,
        stars: 5,
        comment: "متجر ممتاز وتعامل جيد من الموظف بالتوفيق"
    },
    {
        id: "client_2",
        name: "احمد طه",
        pic: client1,
        stars: 4,
        comment: "متجر ممتاز وتعامل جيد من الموظف بالتوفيق"
    },
    {
        id: "client_3",
        name: "همس عبدالله",
        pic: client2,
        stars: 3,
        comment: "متجر ممتاز وتعامل جيد من الموظف بالتوفيق"
    },
    {
        id: "client_4",
        name: "احمد طه",
        pic: client1,
        stars: 5,
        comment: "متجر ممتاز وتعامل جيد من الموظف بالتوفيق"
    },
    {
        id: "client_5",
        name: "احمد طه",
        pic: client1,
        stars: 4,
        comment: "متجر ممتاز وتعامل جيد من الموظف بالتوفيق"
    },
    {
        id: "client_6",
        name: "همس عبدالله",
        pic: client2,
        stars: 3,
        comment: "متجر ممتاز وتعامل جيد من الموظف بالتوفيق"
    },
    {
        id: "client_7",
        name: "احمد طه",
        pic: client1,
        stars: 4,
        comment: "متجر ممتاز وتعامل جيد من الموظف بالتوفيق"
    },
    {
        id: "client_8",
        name: "همس عبدالله",
        pic: client2,
        stars: 3,
        comment: "متجر ممتاز وتعامل جيد من الموظف بالتوفيق"
    }
];

export default clientsOpinions;
